/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetSchedulesGlobals = {
  /**
   * Specify an API version.
   *
   * @remarks
   *
   * API versioning follows the format `vYYYY.QQ.BB`, where
   *   - `YYYY` is the year
   *   - `QQ` is the two-digit month for the first month of the quarter (e.g., 01, 04, 07, 10)
   *   - `BB` is the build number, starting at `.01`, for subsequent builds in the same quarter.
   *     - For example, `v2024.01.00` is the initial release of the first quarter of 2024.
   *
   * The `latest` version represents the most recent development state. It may include breaking changes and should be treated as a beta release.
   * When no version is specified, the API defaults to `v2024.01.00`.
   */
  xMoovVersion?: string | undefined;
};

export type GetSchedulesRequest = {
  accountID: string;
  scheduleID: string;
};

export type GetSchedulesResponse = {
  headers: { [k: string]: Array<string> };
  result: components.ScheduleResponse;
};

/** @internal */
export const GetSchedulesGlobals$inboundSchema: z.ZodType<
  GetSchedulesGlobals,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-Moov-Version": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-Moov-Version": "xMoovVersion",
  });
});
/** @internal */
export type GetSchedulesGlobals$Outbound = {
  "X-Moov-Version"?: string | undefined;
};

/** @internal */
export const GetSchedulesGlobals$outboundSchema: z.ZodType<
  GetSchedulesGlobals$Outbound,
  z.ZodTypeDef,
  GetSchedulesGlobals
> = z.object({
  xMoovVersion: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xMoovVersion: "X-Moov-Version",
  });
});

export function getSchedulesGlobalsToJSON(
  getSchedulesGlobals: GetSchedulesGlobals,
): string {
  return JSON.stringify(
    GetSchedulesGlobals$outboundSchema.parse(getSchedulesGlobals),
  );
}
export function getSchedulesGlobalsFromJSON(
  jsonString: string,
): SafeParseResult<GetSchedulesGlobals, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetSchedulesGlobals$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetSchedulesGlobals' from JSON`,
  );
}

/** @internal */
export const GetSchedulesRequest$inboundSchema: z.ZodType<
  GetSchedulesRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  accountID: z.string(),
  scheduleID: z.string(),
});
/** @internal */
export type GetSchedulesRequest$Outbound = {
  accountID: string;
  scheduleID: string;
};

/** @internal */
export const GetSchedulesRequest$outboundSchema: z.ZodType<
  GetSchedulesRequest$Outbound,
  z.ZodTypeDef,
  GetSchedulesRequest
> = z.object({
  accountID: z.string(),
  scheduleID: z.string(),
});

export function getSchedulesRequestToJSON(
  getSchedulesRequest: GetSchedulesRequest,
): string {
  return JSON.stringify(
    GetSchedulesRequest$outboundSchema.parse(getSchedulesRequest),
  );
}
export function getSchedulesRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetSchedulesRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetSchedulesRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetSchedulesRequest' from JSON`,
  );
}

/** @internal */
export const GetSchedulesResponse$inboundSchema: z.ZodType<
  GetSchedulesResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  Headers: z.record(z.array(z.string())).default({}),
  Result: components.ScheduleResponse$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "Headers": "headers",
    "Result": "result",
  });
});
/** @internal */
export type GetSchedulesResponse$Outbound = {
  Headers: { [k: string]: Array<string> };
  Result: components.ScheduleResponse$Outbound;
};

/** @internal */
export const GetSchedulesResponse$outboundSchema: z.ZodType<
  GetSchedulesResponse$Outbound,
  z.ZodTypeDef,
  GetSchedulesResponse
> = z.object({
  headers: z.record(z.array(z.string())),
  result: components.ScheduleResponse$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    headers: "Headers",
    result: "Result",
  });
});

export function getSchedulesResponseToJSON(
  getSchedulesResponse: GetSchedulesResponse,
): string {
  return JSON.stringify(
    GetSchedulesResponse$outboundSchema.parse(getSchedulesResponse),
  );
}
export function getSchedulesResponseFromJSON(
  jsonString: string,
): SafeParseResult<GetSchedulesResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetSchedulesResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetSchedulesResponse' from JSON`,
  );
}
